import { render, staticRenderFns } from "./NewSearchBox.vue?vue&type=template&id=008ba226&"
import script from "./NewSearchBox.vue?vue&type=script&lang=js&"
export * from "./NewSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports